import cn from 'classnames';
import React from 'react';
import './TileGrid.scss';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TileGridProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * Responsive grid that contains multiple tiles.
 */
export const TileGrid: React.FC<TileGridProps> = ({ className, children }) => {
  return (
    <div data-cy="tileGrid" className={cn('tileGrid', className)}>
      {children}
    </div>
  );
};
